// extracted by mini-css-extract-plugin
module.exports = {"root":"dh-dh-klima-spesial-english-root--f57b2d7cc02b9879ddbb595a70515f35","app":"dh-dh-klima-spesial-english-app--5638d17ff8355b55f816045feef1ed1b"};